import { FC, useEffect } from 'react'
import { GetServerSideProps } from 'next'

import WebinarSearchLayout from 'containers/webinar-layout/webinar-layout'
import SEOBreadCrumbs from 'components/parts/seo-metatags/seo-breadcrumbs'
import SEOMetatags from 'components/parts/seo-metatags/seo-metatags'

import nestRequest from 'utils/server-side/nestRequest'
import { SEOType } from 'constants/SEO'
import { INewslineCard, IWebinarCard } from 'constants/types/card.types'
import { WebinarVideoprojectBC } from 'constants/SEO-breadcrumbs'
import { CARDS_ON_PAGE } from 'constants/search-data/search-data'
import { A_w_sectionToggle, sectionName } from 'utils/analytics/webinars/webinar_section'
import { useARegAndLogin, originReg } from 'utils/analytics/other/registration/registration'

const PAGE_LIMIT = 2

const VideoProjectSEO = (page: number) => {
  const pageString = page >= PAGE_LIMIT ? ` - Страница ${page}` : ''
  return {
    [SEOType.TITLE]: `Видеопроекты для врачей на Medpoint ${pageString}`,
    [SEOType.DESCRIPTION]: `Видеопроекты для врачей. Дистанционное медицинское обучение НМО для врачей всех специальностей при поддержке РНИМУ им. Пирогова ${pageString}`,
    [SEOType.LINK]: `${URL}/webinar/videoprojects`,
  }
}

interface IVideoProject {
  pageValue: number
  initCards: {
    count: number
    rows: INewslineCard[] | IWebinarCard[]
  }
}

const VideoProject: FC<IVideoProject> = ({ pageValue, initCards }) => {
  const titlePage =
    pageValue >= PAGE_LIMIT
      ? `Видеопроекты для врачей <span>Cтраница ${pageValue}</span>`
      : 'Видеопроекты для врачей'

  useEffect(() => {
    A_w_sectionToggle(sectionName.VIDEOPROJECTS)
  }, [])

  useARegAndLogin(originReg.WEBINAR_LIST)

  return (
    <>
      <SEOMetatags data={VideoProjectSEO(pageValue)} />
      <SEOBreadCrumbs data={WebinarVideoprojectBC} />
      <WebinarSearchLayout initCards={initCards} title={titlePage}></WebinarSearchLayout>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  let initCards = []
  const offset = context.query.page ? CARDS_ON_PAGE * (Number(context.query.page) - 1) : 0

  try {
    let result = null

    result = await nestRequest(context, 'get', `/api/playlist`, {
      limit: CARDS_ON_PAGE,
      count: true,
      offset: offset,
    })

    if (result !== null && result?.status !== 200) throw new Error('rest request error')

    initCards = result?.data || []
  } catch (err) {
    console.log(err)
  }

  return {
    props: {
      initCards,
      pageValue: context.query.page || 1,
    },
  }
}
export default VideoProject
